module.exports = __webpack_public_path__ + "img/product-sample.3434a313.png";